(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller('manageUsers', manageUsers);

	manageUsers.$inject = ['$rootScope', '$scope', '$timeout', '$location',
		'leanFilterService', 'tableRenderService', 'tableService', 'URLS', 'supplierListService', '$q', 'uploadUserModalService',
		'$experiments', 'FIRST_VIEW'];

	function manageUsers($rootScope, $scope, $timeout, $location,
			leanFilterService, tableRenderService, tableService, URLS, supplierListService, $q, uploadUserModalService,
			$experiments, FIRST_VIEW) {
		var vm = this;
		var rendererParams = {};
		var firstLoad = true;
		var extraParams = [{ excelReportName: 'ManageUsers' }];
		var reportSettingsName = 'UserManagement';
		vm.useReactReport = $experiments.isEnabled('react-user-management');
		vm.viewType = FIRST_VIEW.REPORTSETTINGSNAME_TO_VIEWTYPE[reportSettingsName] || '';

		var defaultFilters = [{
			'id': 'role',
			'values': [leanFilterService.leanDnaAllSelected]
		},
		{
			'id': 'profileType',
			'values': [leanFilterService.leanDnaAllSelected]
		},
		{
			'id': 'allFactory',
			'values': [leanFilterService.leanDnaAllSelected],
			'isMandatory': true
		},
		{
			'id': 'activated',
			'values': ['active']
		}];

		var importTemplates = {
			'newUsers': {
				's3XLSXFilePath': 'NewUsers',
				'template': '/application/f/setup/users/user-upload-modal.html',
				'uploadPath': '/User/Import/Create',
				'uploadResultTemplate': '/application/f/setup/users/user-upload-result.html'
			},
			'newSuppliers': {
				's3XLSXFilePath': 'NewSupplierUsers',
				'template': '/application/f/setup/users/supplier-upload-modal.html',
				'uploadPath': '/User/Import/Create?isSupplier=true',
				'uploadResultTemplate': '/application/f/setup/users/user-upload-result.html',
				'isSupplier': true
			},
			'addSites': {
				's3XLSXFilePath': 'AddUsersToSites',
				'template': '/application/f/setup/users/add-site-upload-modal.html',
				'uploadPath': '/User/Import/AddSite',
				'uploadResultTemplate': '/application/f/setup/users/add-site-result.html'
			},
			'addSitesForSuppliers': {
				's3XLSXFilePath': 'AddSuppliersToSites',
				'template': '/application/f/setup/users/add-supplier-to-sites-upload-modal.html',
				'uploadPath': '/User/Import/AddSite?isSupplier=true',
				'uploadResultTemplate': '/application/f/setup/users/add-site-result.html',
				'isSupplier': true
			}
		};
		
		$scope.$on('updateNoneSelected', function (event, args) {
			vm.noneSelected = args.noneSelected;
			vm.showDeactivateUserDisabled = args.noneSelected;
		});

		var isKeiAllowed = (globalConfig.defaultFeatures['kei-ai'] && globalConfig.user.canAccessKei) || $rootScope.authz.isLeanDNACustomerAdmin();

		var columns = [{
			'id': 'isChecked',
			'display': '$checkbox',
			'customHeaderClass': 'checkboxCell alignCenter',
			'renderer': tableRenderService.checkboxRenderer,
			'sort': false,
			'hideMenu': true,
			'disabledShowHide': true,
			'width': 45,
			'pinnedLeft': true
		},
		{
			'id': 'name',
			'display': 'Name',
			'renderer': tableRenderService.personNameRenderer,
			'width': 200,
			'pinnedLeft': true
		},
		{
			'id': 'emailAddress',
			'display': 'Email Address',
			'renderer': tableRenderService.emailAddressRenderer,
			'width': 200
		},
		{
			'id': 'profileTypeDisplay',
			'display': 'Privileges',
			'width': 100,
			'show': false,
			'sort': false
		},
		{
			'id': 'roleTypeDisplay',
			'display': 'Role',
			'width': 100,
			'sort': false
		},
		{
			'id': 'isSmeCertified',
			'display': 'SME Certified',
			'renderer': tableRenderService.yesNo,
			'width': 100,
			'sort': true
		},
		{
			'id': 'isWorkbenchSupervisor',
			'display': 'Workbench Supervisor',
			'renderer': tableRenderService.yesNo,
			'width': 100,
			'sort': true
		},
		{
			'id': 'supplierNdxs',
			'display': 'Supplier',
			'displayText': 'Supplier',
			'renderer': tableRenderService.resolveSupplierNdxs,
			'width': 100,
			'sort': false
		},
		{
			'id': 'dateCreated',
			'display': 'Account Creation Date',
			'renderer': tableRenderService.dateRenderer,
			'width': 150,
			'show': false
		},
		{
			'id': 'lastActivity',
			'display': 'Last Access Date',
			'renderer': tableRenderService.lastAccessRenderer,
			'width': 200
		},
		{
			'id': 'active',
			'display': 'Active',
			'renderer': tableRenderService.yesNo,
			'width': 100
		},
		{
			'id': 'isSingleSignOn',
			'display': 'Single Sign On',
			'renderer': tableRenderService.yesNo,
			'show': false,
			'width': 100
		},
		{
			'id': 'isComputerActivationEnabled',
			'display': 'Computer Activation Enabled',
			'renderer': tableRenderService.yesNo,
			'show': false,
			'width': 100
		},
		{
			'id': 'approveProjects',
			'display': 'Approve lean projects',
			'renderer': tableRenderService.yesNo,
			'width': 100,
			'sort': true
		},
		{
			'id': 'canAccessIOP',
			'display': 'Inventory optimization access',
			'renderer': tableRenderService.yesNo,
			'width': 100,
			'sort': true
		}
		];

		if (isKeiAllowed) {
			columns.push({
				'id': 'canAccessKei',
				'display': 'Can use Kei',
				'renderer': tableRenderService.yesNo,
				'width': 100,
				'sort': true
			});
		}

		if ($rootScope.authz.isLeanDNAAdmin()) {
			var userIdColumn = {
				'id': 'userNdx',
				'display': 'User ID',
				'active': false,
				'width': 100
			};
			columns.splice(1, 0, userIdColumn);
		}

		$scope.filterService = leanFilterService;

		var meta = {
			reportSettingsName: reportSettingsName,
			reportUrl: '{0}/ManageUsersReport',
			noPaging: false,
			columns: columns,
			pinnedColumns: [],
			defaultFilters: defaultFilters,
			defaultSort: 'name',
			defaultSortDirection: 'asc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			pageSize: 50,
			setColumnDefaults: true,
			waitForFilters: true,
			searchType: 'user',
			reportSettingsScope: 'customer',
			useReportBuilderForExcel: true
		};

		vm.showDeactivateUserDisabled = true;
		vm.noneSelected = true;
		vm.showDeactivateUser = true;
		vm.showCreateUser = $rootScope.authz.isAdmin();
		vm.reportName = 'Manage Users';
		vm.showExcel = true;
		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.deactivateSelectedUsers = deactivateSelectedUsers;
		vm.broadcastExcel = broadcastExcel;
		vm.showImportUser = ($rootScope.authz.isSuperAdmin() || $rootScope.authz.isLeanDNACustomerAdmin());
		vm.usermanagementImportData = usermanagementImportData;

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams, columns) {
			if (!supplierListService.isLoaded()) {
				return $q.all([supplierListService.loadSupplierList()]).then(function () {
					return getDataInner(params, extraParams, columns);
				});
			} else {
				return getDataInner(params, extraParams, columns);
			}
		}

		function getDataInner(params, extraParams) {
			return tableService.postData(params, extraParams, columns).then(function (response) {
				if (firstLoad) {
					setHeaderExtraInfo();
					firstLoad = false;
				}
				return response;
			});
		}

		function userIsAdminForOtherCustomers() {
			if ($rootScope.authz.isLeanDNAAdmin()) {
				return true;
			}
			var sitesForOtherCustomers = _.filter(globalConfig.user.authFacts, function (site) {
				return site.customerNdx !== globalConfig.customer.id && site.profileType.toLowerCase().includes('admin');
			});
			return sitesForOtherCustomers && (sitesForOtherCustomers.length > 0);
		}

		function setHeaderExtraInfo() {
			var supplierColumnDefinition = _.filter(columns, function (column) { return column.id === 'supplierNdxs'; });
			if (userIsAdminForOtherCustomers() && supplierColumnDefinition) {
				supplierColumnDefinition[0].display = '<span translate>' + supplierColumnDefinition[0].displayText + '</span> <span class="fa fa-info-circle" translate title="Showing suppliers for customer ' + globalConfig.customer.name + ' only. To view suppliers for other customers, switch to a different customer."></span>';
			}
		}

		function deactivateSelectedUsers() {
			$scope.$broadcast('deactivateSelectedUsers');
		}

		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', { 
				doChooseColumns: false,
				includeAllColumnsForExcel: true
			});
		}

		function usermanagementImportData(type) {
			uploadUserModalService.openImportModal(importTemplates[type], $rootScope, $scope);
		}

		function init() {
			if ($location.search() && $location.search().message) {
				$rootScope.$emit('toast', {
					'message': $location.search().message
				});
			}
			var sitesFilter = $scope.filterService.filterDefinitions.AllFactories;
			if (!$rootScope.authz.isSuperAdmin()) {
				sitesFilter = _.assign({}, sitesFilter, { sendAllValues: true, url: URLS.allFactories + '?sameCustomer=true' });
			}
			sitesFilter.removable = false;
			var bouncedFilter = $scope.filterService.filterDefinitions.EmailBounced;
			bouncedFilter.displayName = 'Email Deactivated';

			$scope.filterService.clearFilters();
			$scope.filterService.useAdminFactory = true;

			var filters = [
				sitesFilter,
				$scope.filterService.filterDefinitions.RoleType,
				$scope.filterService.filterDefinitions.ProfileType,
				$scope.filterService.filterDefinitions.Activated,
				$scope.filterService.filterDefinitions.SupplierByAdminAccess,
				$scope.filterService.filterDefinitions.SmeCertified,
				$scope.filterService.filterDefinitions.WorkbenchSupervisor,
				bouncedFilter,
				$scope.filterService.filterDefinitions.CanAccessIOP
			];

			if (isKeiAllowed) {
				filters.push($scope.filterService.filterDefinitions.CanAccessKei);
			}

			$scope.filterService.setMasterFilterList(filters);
			$scope.filterService.setMasterRangeFilterList([
				$scope.filterService.filterDefinitions.LastActivity
			]);
		}

		init();
	}
})();
